export default "__VITE_ASSET__59770bc0__"